"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapseIcon = function CollapseIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "9",
    role: "presentation",
    viewBox: "0 0 16 9",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.2734 8.97656L8 1.71094L0.726563 8.97656L0.0234375 8.27344L8 0.289062L15.9766 8.27344L15.2734 8.97656Z"
  }));
};

CollapseIcon.defaultProps = {
  className: undefined
};
CollapseIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = CollapseIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb2xsYXBzZUljb24iLCJjbGFzc05hbWUiLCJkZWZhdWx0UHJvcHMiLCJ1bmRlZmluZWQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJzdHJpbmciXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9Db2xsYXBzZUljb24uanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENvbGxhcHNlSWNvbiA9ICh7IGNsYXNzTmFtZSB9KSA9PiAoXG4gIDxzdmdcbiAgICBjbGFzc05hbWU9eyhjbGFzc05hbWUgfHwgJycpICsgJyd9XG4gICAgZm9jdXNhYmxlPXtmYWxzZX1cbiAgICBoZWlnaHQ9XCI5XCJcbiAgICByb2xlPVwicHJlc2VudGF0aW9uXCJcbiAgICB2aWV3Qm94PVwiMCAwIDE2IDlcIlxuICAgIHdpZHRoPVwiMTZcIlxuICAgIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIlxuICA+XG4gICAgPHBhdGggZD1cIk0xNS4yNzM0IDguOTc2NTZMOCAxLjcxMDk0TDAuNzI2NTYzIDguOTc2NTZMMC4wMjM0Mzc1IDguMjczNDRMOCAwLjI4OTA2MkwxNS45NzY2IDguMjczNDRMMTUuMjczNCA4Ljk3NjU2WlwiIC8+XG4gIDwvc3ZnPlxuKTtcblxuQ29sbGFwc2VJY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgY2xhc3NOYW1lOiB1bmRlZmluZWRcbn07XG5cbkNvbGxhcHNlSWNvbi5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZ1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29sbGFwc2VJY29uO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQSxJQUFNQSxZQUFZLEdBQUcsU0FBZkEsWUFBZTtFQUFBLElBQUdDLFNBQUgsUUFBR0EsU0FBSDtFQUFBLG9CQUNuQjtJQUNFLFNBQVMsRUFBRSxDQUFDQSxTQUFTLElBQUksRUFBZCxJQUFvQixFQURqQztJQUVFLFNBQVMsRUFBRSxLQUZiO0lBR0UsTUFBTSxFQUFDLEdBSFQ7SUFJRSxJQUFJLEVBQUMsY0FKUDtJQUtFLE9BQU8sRUFBQyxVQUxWO0lBTUUsS0FBSyxFQUFDLElBTlI7SUFPRSxLQUFLLEVBQUM7RUFQUixnQkFTRTtJQUFNLENBQUMsRUFBQztFQUFSLEVBVEYsQ0FEbUI7QUFBQSxDQUFyQjs7QUFjQUQsWUFBWSxDQUFDRSxZQUFiLEdBQTRCO0VBQzFCRCxTQUFTLEVBQUVFO0FBRGUsQ0FBNUI7QUFJQUgsWUFBWSxDQUFDSSxTQUFiLEdBQXlCO0VBQ3ZCSCxTQUFTLEVBQUVJLGtCQUFBLENBQVVDO0FBREUsQ0FBekI7ZUFJZU4sWSJ9